<template lang="pug">
.field-group
	.field-group__controller
		v-field(
			:field="localField.checkbox"
			v-model="localField.checkbox.value"
			@update:model-value="updateFieldValue"
		)

	v-collapse(:open="localField.checkbox?.value?.length")
		.field-group__list
			template(v-for="(field, index) in localField.fields" :key="index")
				.field-group__item(:style="{width: field.width || null}")
					v-field(:field="field" v-model="field.value" @update:model-value="updateFieldValue" )
</template>

<script>
	import {cloneDeep} from "lodash";

	export default {
		props: {
			field: {
				type: Object,
				default: null,
				required: true
			},

			modelValue: {
				type: [Array, Object, String, Number, Boolean, Symbol, Date],
				default: null
			}
		},

		emits: [
			'update:model-value'
		],

		data() {
			return {
				localCheckboxValue: false,
				localFieldData: {},
				localField: null,
			}
		},

		methods: {
			handleInput() {

			},
			updateLocalValue() {
				this.localFieldData = this.modelValue;
			},

			proxyFieldName(name) {
				//return `${this.field.name}[${name}]`;
			},

			updateFieldValue() {
				let data = {}

				let {
					checkbox = null
				} = this.localField;

				if(checkbox && checkbox?.value?.length) {
					data[checkbox.name] = checkbox.value;

					if(this.localField.fields && this.localField.fields.length) {
						this.localField.fields.reduce((acc, curr, index) => {
							if(curr.value ) {
								acc[curr.name] = curr.value;
							}
							return acc;
						}, data)
					}

				}

				this.localFieldData = data;

				this.$emit('update:model-value', this.localFieldData);
			},
		},


		watch: {
			field: {
				immediate: true,
				handler() {
					this.localField = cloneDeep(this.field);
					this.localCheckboxValue = [...this.field.checkbox.value];
					this.updateFieldValue();
				}
			},
			modelValue() {
				this.updateLocalValue();
			}
		},

		created() {
			this.updateFieldValue();
		}
	}
</script>